export default __webpack_public_path__ + "static/media/12216103 - Mohit Chaudhary.9ac8ad2d.jpg";